import { sorting } from '@/mixins'
import { storePagination } from '@/mixins/store'
import axios from '@axios'

const getInitialState = () => ({
  ...storePagination.state(),
  productUnits: [],
  filters: { name: '', status: null },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {},

  mutations: {
    ...storePagination.mutations,

    SET_PRODUCT_UNITS(state, productUnits) {
      state.productUnits = productUnits
    },
    SET_FILTER(state, filters) {
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { filters, paging, productUnits } = getInitialState()
      state.filters = filters
      state.productUnits = productUnits
      state.paging = paging
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchProductUnits({ commit, state }) {
      const { data } = await axios.get('/api/units', {
        params: {
          name: state.filters.name ? state.filters.name : '',
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_PRODUCT_UNITS', data.results)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount,
        rowsInCurrentPage: data.rowsInCurrentPage,
      })
    },

    setFilters({ commit }, filters) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTER', filters)
    },

    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTER', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
